import React from 'react';
import SectionHeading from '../shared/SectionHeading';

const valuePoints = [
  {
    title: 'Clear recommendations',
    description: 'We explain the issue, outline the options, and keep the conversation practical.',
  },
  {
    title: 'Comfort-first scheduling',
    description: 'Fast response matters when the house is too hot or too cold, especially during seasonal extremes.',
  },
  {
    title: 'Work sized to the home',
    description: 'Repairs and replacement recommendations should match the home, the equipment, and the budget.',
  },
  {
    title: 'Local service area focus',
    description: 'A Salt Lake County service area keeps scheduling more predictable and support more consistent.',
  },
];

const WhyChooseUs = () => (
  <section className="section">
    <div className="container why-choose-us">
      <div>
        <SectionHeading
          eyebrow="Why Homeowners Call"
          title="A more direct service experience from first call to final walkthrough."
          description="You get practical options, clear communication, and recommendations based on the equipment, the home, and your comfort priorities."
        />
      </div>
      <div className="responsive-grid responsive-grid-2">
        {valuePoints.map((point) => (
          <article key={point.title} className="card value-card">
            <h3>{point.title}</h3>
            <p>{point.description}</p>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default WhyChooseUs;
